import { CheckCircle2, FileText, Home, Truck } from "lucide-react";
import { Link, useParams } from "react-router-dom";

export function OrderSuccessPage() {
  const { orderId = "STUT-260829-001" } = useParams();

  return (
    <main className="page-canvas">
      <section className="container success-page">
        <div className="success-card">
          <CheckCircle2 aria-hidden="true" />
          <h1>Đặt hàng thành công</h1>
          <p>Mã đơn {orderId} đã được ghi nhận. Email xác nhận sẽ gửi qua Pages Function + Resend.</p>
          <div className="timeline">
            <span className="active">Đã tạo đơn</span>
            <span>Chờ xác nhận</span>
            <span>Đóng gói</span>
            <span>Bàn giao</span>
          </div>
          <div className="success-actions">
            <Link className="btn btn-primary" to={`/account/orders/${orderId}`}>
              <FileText aria-hidden="true" />
              <span>Xem chi tiết</span>
            </Link>
            <Link className="btn btn-secondary-light" to="/track-order">
              <Truck aria-hidden="true" />
              <span>Tra cứu vận chuyển</span>
            </Link>
            <Link className="btn btn-ghost" to="/">
              <Home aria-hidden="true" />
              <span>Trang chủ</span>
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
